import { render, staticRenderFns } from "./sticky_header.vue?vue&type=template&id=f396c904"
import script from "./sticky_header.vue?vue&type=script&lang=js"
export * from "./sticky_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports